'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _memoizeOne = require('memoize-one');

var _memoizeOne2 = _interopRequireDefault(_memoizeOne);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Select = require('../Select');

var _Select2 = _interopRequireDefault(_Select);

var _currencyCodes = require('./currencyCodes');

var _currencyCodes2 = _interopRequireDefault(_currencyCodes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var emojiContainerStyle = {
  display: 'flex',
  alignItems: 'center'
};
var emojiStyle = {
  display: 'inline-block',
  width: '18px'
};

var CurrencySelector = function (_PureComponent) {
  _inherits(CurrencySelector, _PureComponent);

  function CurrencySelector() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CurrencySelector);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CurrencySelector.__proto__ || Object.getPrototypeOf(CurrencySelector)).call.apply(_ref, [this].concat(args))), _this), _this.onChangeCurrency = function (currency) {
      var onChange = _this.props.onChange;
      onChange(currency);
    }, _this.getCurrencyCodes = (0, _memoizeOne2.default)(function (disabledCurrencies) {
      // This prevents every currency selector from making a copy of the list of currencies.
      // Because the common use case is to not disable currencies, most selectors will not copy the list.
      if (!disabledCurrencies || disabledCurrencies.length === 0) {
        return _currencyCodes2.default;
      }

      var disabledCurrencySet = new Set(disabledCurrencies);

      var currencies = _currencyCodes2.default.map(function (currency) {
        return disabledCurrencySet.has(currency.value) ? _extends({}, currency, {
          disabled: true
        }) : currency;
      });

      return currencies;
    }), _this.renderFlag = function (info) {
      var displayFullName = _this.props.displayFullName;
      var value = info.value,
          label = info.label,
          flag = info.flag;
      return _react2.default.createElement('div', {
        style: emojiContainerStyle
      }, _react2.default.createElement('span', {
        style: emojiStyle,
        dangerouslySetInnerHTML: {
          __html: flag
        }
      }), '\xA0 ', displayFullName ? label + ' (' + value + ')' : value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CurrencySelector, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          clearable = _props.clearable,
          currency = _props.currency,
          disabled = _props.disabled,
          disabledCurrencies = _props.disabledCurrencies,
          label = _props.label,
          required = _props.required;
      var currencyClassName = 'currency-select ' + className;
      var currencyCodes = this.getCurrencyCodes(disabledCurrencies);
      return _react2.default.createElement(_Select2.default, {
        required: required,
        label: label,
        disabled: disabled,
        className: currencyClassName,
        optionRenderer: this.renderFlag,
        valueRenderer: this.renderFlag,
        clearable: clearable,
        onChange: this.onChangeCurrency,
        options: currencyCodes,
        tether: true,
        value: currency
      });
    }
  }]);

  return CurrencySelector;
}(_react.PureComponent);

CurrencySelector.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  className: _propTypes2.default.string,
  currency: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  disabledCurrencies: _propTypes2.default.arrayOf(_propTypes2.default.string),
  label: _propTypes2.default.string,
  required: _propTypes2.default.bool,
  displayFullName: _propTypes2.default.bool,
  clearable: _propTypes2.default.bool
};
CurrencySelector.defaultProps = {
  disabled: false,
  disabledCurrencies: [],
  className: '',
  required: false,
  displayFullName: false,
  clearable: false,
  currency: null,
  label: 'Currency'
};
exports.default = CurrencySelector;